import React, { useEffect, useState } from 'react';
import { GridSkeleton } from 'components/Grid';
import ScalarSpreadsheet from 'components/ScalarSpreadsheet';
import useWorkbook from 'components/ScalarSpreadsheet/utilities/useWorkbook';
import useWaterfallTableData from '../hooks/useWaterfallTableData';
import { IWaterfallCalculatorTableProps } from '../types';

const WaterfallCalculatorTable = (props: IWaterfallCalculatorTableProps) => {
  const { isLoading, exitEquityValue, data, format, formatDispatch } = props;

  const { spreadsheet: waterfallCalculatorSheet } = useWaterfallTableData({ exitEquityValue, data, format });

  const [spreadsheets, setSpreadsheets] = useState([waterfallCalculatorSheet]);

  useEffect(() => {
    if (waterfallCalculatorSheet?.yLength > 0) {
      setSpreadsheets([waterfallCalculatorSheet]);
    }
  }, [waterfallCalculatorSheet]);

  const { onChange, workbook } = useWorkbook(spreadsheets);

  if (isLoading) {
    return <GridSkeleton />;
  }

  if (!waterfallCalculatorSheet?.data) {
    return null;
  }

  const waterfallCalculatorSheetProps = {
    ...waterfallCalculatorSheet,
    sheet: waterfallCalculatorSheet || {},
    workbook,
    onChange,
    page: 'Waterfall Calculator',
    format,
    formatDispatch,
    data: waterfallCalculatorSheet?.data,
  };

  return <ScalarSpreadsheet {...waterfallCalculatorSheetProps} />;
};

export default WaterfallCalculatorTable;
